
$(document).ready(function(){
	init_typecat_sel();
	onTeisesAktaiChangeType();
	init_acts();
});

function init_teises_aktai()
{
//	init_typecat_sel();
//	$('#search_category').select2("val", $('#search_category').attr('rel'));
//	onTeisesAktaiChangeType();
}


function init_typecat_sel()
{
	if ($('#sort_id').val() == -1){
		$("#type_id").select2("enable", false);
		$(".type_title").addClass('blur');
	}
	$('#sort_id').on('change', function (){
		if ($('#sort_id').val() == -1){
			$("#type_id").select2("enable", false);
			$(".type_title").addClass('blur');
		}else{
			$("#type_id").select2("enable", true);
			$(".type_title").removeClass('blur');
		}
	});		
}

function onTeisesAktaiChangeType()
{
	$("#text_incontent, #text_intitle").select2("enable", false);
	
	$('#incontent').bind('keyup blur', function(){
		
		if($(this).val().length > 0) {
			$("#text_incontent").select2("enable", true);
		} else {
			$("#text_incontent").select2("enable", false);
		}
	});
	$('#intitle').bind('keyup blur', function(){
		if($(this).val().length > 0) {
			$("#text_intitle").select2("enable", true);
		} else {
			$("#text_intitle").select2("enable", false);
		}
	});
	
	$('#incontent, #intitle').keyup();
}

function init_acts() {
	
	$('.category').click(function(){		
		$(this).parent().find('.category_questions').slideToggle();
		$(this).children('.catNameOuter').toggleClass('act');
	});
	
	$('.question').click(function(){
		$(this).parent().find('.answer').slideToggle();
		$(this).children('.questionNameOuter').toggleClass('act');
	});
	//form
	$('.show_search_form').click(function(){
		if($('.more_search').hasClass('hidden')){ //this is the start of our condition 
			$('.more_search').show('fast').slideDown();
			$('.more_search').removeClass('hidden');
			$('.detail_search_icon').addClass('arrow_up');
		} else {
			$('.more_search').hide('fast').slideUp();
			$('.more_search').addClass('hidden');
			$('.detail_search_icon').removeClass('arrow_up');
		}
	});
    
}